// extracted by mini-css-extract-plugin
module.exports = {"c-PortalSidebar":"PortalSidebar_c-PortalSidebar__N4fg5","c-PortalSidebar__left_nav_panel":"PortalSidebar_c-PortalSidebar__left_nav_panel__wqfDr"};